import { Component, ViewChild } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormBuilder,
  FormArray,
  Validators,
} from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ValidationService } from 'src/app/service/validation.service';
import { ResponseStatus } from 'src/enum/responseEnum';
import {
  emailValidator,
  pinCodeValidator,
  pancardValidater,
  phoneValidator,
  urlValidator,
  expiryDateValidator,
} from 'src/validator';
import { RegisterService } from 'src/app/service/register.service';
import { ProfileService } from 'src/app/service/profile.service';
import { SlickCarouselComponent } from 'ngx-slick-carousel';
import { DatePipe, Location } from '@angular/common';
import { CustomSnackbarService } from 'src/app/components/custom-notification/custom-notification.component';
import { retry, takeWhile } from 'rxjs';
import { MatDatepicker, MatDatepickerInputEvent } from '@angular/material/datepicker';
@Component({
  selector: 'app-validation-detail',
  templateUrl: './validation-detail.component.html',
  styleUrls: ['./validation-detail.component.css'],
})
export class ValidationDetailComponent {
  title1 = 'Validation';
  title = 'Seller Information';
  title2 = 'Document Validation';



  @ViewChild(MatDatepicker) datePicker!: MatDatepicker<Date>;

  businessParam: string = '';
  sellerProfilePageData: any = {};
  @ViewChild('carousel1') carousel1!: SlickCarouselComponent;
  ispageLoading: boolean = false;
  today: any = new Date();
  qualificationList: any = [];

  businessWorkFlowESCALATE: any = [];
  businessWorkFlowFOLLOW: any = [];
  businessWorkFlowApproved: any = [];
  businessWorkFlowReject: any = [];

  subCategoryList: any = [];
  proCategoryList: any = [];
  businessWorkFlow: any[] = [];
  businessWorkFlowTmp: any[] = [];
  legalDocumentId: number = 0;
  myForm: any = FormGroup;
  docFormGroup: any = FormGroup;
  loading: boolean = true;
  validationId: any = '';
  persentMode: any = '';
  validationDocuments: any = [];
  selectedFile: any = { value: '', fields: [] };
  selectReason: number = 1;
  cityList: any = [];
  filteredCity: any = [];
  stateList: any = [];
  filteredState: any = [];
  docStatusList: any[] = [];
  documentAcceptanceData: any = [];
  userInfo: any = {};
  date: any;
  followup: boolean = false;
  esclate: boolean = false;
  private loadingCounter: number = 0;
  selectStatusTitle = "Select Status";
  showAfterContent: boolean = false;
  currentStatusName= '';
  expireDateError: boolean = false;
  docVerifyError: boolean = false;
  expireDateVal: any = null;
  docVerifyVal: any = null;
  expireDateOnOffVal: boolean = false;
  docVarifyOnOffVal: boolean = false;

  currentStatus!: any;

  reasonArray: any = [
    { id: 1, name: 'Document Expired' },
    { id: 2, name: 'Fake Document' },
    { id: 3, name: 'Document is Not Clear' },
    { id: 4, name: 'Incorrect Document' },
    { id: 5, name: 'Others' },
  ];

  mapBusinesstype: any = [
    { id: 1, name: 'Online', stringId: 'ONLINE' },
    { id: 2, name: 'Services', stringId: "SERVICE" },
    { id: 3, name: 'Local business', stringId: "LOCAL_BUSINESS" },
  ];


  togglefollowup() {
    this.followup = !this.followup;
  }
  toggleesclate() {
    this.esclate = !this.esclate;
  }
  carouselConfig = {
    slidesToShow: 3,
    arrows: true,
    autoplay: false,
    infinite: false,
    prevArrow:
      '<button class="pbt vbtn"><img src="./assets/images/prev-solid.svg"></button>',
    nextArrow:
      '<button class="nbt vbtn"><img src="./assets/images/next-solid.svg"></button>',
    autoplaySpeed: 3000,
    // variableWidth: true,
  };

  constructor(
    private validationService: ValidationService,
    private route: ActivatedRoute,
    public sanitizer: DomSanitizer,
    private register: RegisterService,
    private fb: FormBuilder,
    private profileService: ProfileService,
    private datePipe: DatePipe,
    private customSnackbarService: CustomSnackbarService,
    private _location: Location,
    private router: Router,
    private location: Location
  ) {
    this.fetchAllBusinessWorkFlow();


    this.myForm = new FormGroup({
      firstName: new FormControl({ value: '', disabled: false }, [
        Validators.required,
      ]),
      lastName: new FormControl({ value: '', disabled: false }, [
        Validators.required,
      ]),
      contactNumber: new FormControl({ value: '', disabled: false }, [
        Validators.required,
        phoneValidator(),
      ]),
      emailId: new FormControl({ value: '', disabled: false }, [
        Validators.required,
        emailValidator(),
      ]),
      cityId: new FormControl({ value: '', disabled: false }, [
        Validators.required,
      ]),
      stateId: new FormControl({ value: '', disabled: false }, []),
      pincode: new FormControl({ value: '', disabled: false }, [
        Validators.required,
        pinCodeValidator(),
      ]),
      salutationId: new FormControl(
        { value: this.selectReason, disabled: false }
      ),
      dateOfBirth: new FormControl({ value: '', disabled: false }, [
        Validators.required,
      ]),
      eduQualificationId: new FormControl({ value: '0', disabled: false },
        [
          Validators.required,
        ])
      ,

      /// business info
      id: new FormControl({ value: '', disabled: false }),
      legalBusinessName: new FormControl(
        { value: '', disabled: false }
      ),
      businessEmailId: new FormControl({ value: '', disabled: false }, [
        // Validators.required,
        emailValidator(),
      ]),
      websiteURL: new FormControl({ value: '', disabled: false }, [
      ]),
      businessNumber: new FormControl({ value: '', disabled: false }, [
      ]),
      whatsappNumber: new FormControl({ value: '', disabled: false }, [
      ]),
      registeredAddress: new FormControl({ value: '', disabled: false }, [
        Validators.required,
      ]),
      custSupportNo: new FormControl({ value: '', disabled: false }, [

      ]),
      businessIncorporationDate: new FormControl(
        { value: '', disabled: false }
      ),
      custSupportEmailId: new FormControl({ value: '', disabled: false }, [
        // Validators.required,
        emailValidator(),
      ]),
      entityTypeID: new FormControl({ value: '', disabled: false }),
      businessStateId: new FormControl({ value: '', disabled: false }),

      // Document type pan
      businessNamePanCard: new FormControl({ value: false, disabled: false }),
      panNumberPanCard: new FormControl({ value: false, disabled: false }, [
        Validators.required,
      ]),
      businessIncorporationDatePanCard: new FormControl(
        { value: false, disabled: false },
        [Validators.required]
      ),
      issueDatePanCard: new FormControl({ value: false, disabled: false }, [
        Validators.required,
      ]),

      // Document type Adhar
      gstNumber: new FormControl({ value: false, disabled: false }, [
        Validators.required,
      ]),
      gstIssueDate: new FormControl({ value: false, disabled: false }, [
        Validators.required,
      ]),
      gstBusinesslegalName: new FormControl({ value: false, disabled: false }, [
        Validators.required,
      ]),
      gstEntityType: new FormControl({ value: false, disabled: false }, [
        Validators.required,
      ]),
      gstRegistedBusinessAddress: new FormControl(
        { value: false, disabled: false },
        [Validators.required]
      ),

      proCategory: new FormControl({ value: '', disabled: false }),
      subCategory: new FormControl({ value: '', disabled: false }),
      otherDocumentNumber: new FormControl({ value: false, disabled: false }),
      otherDocumentIssueDate: new FormControl({ value: false, disabled: false }),
      selectStatus: new FormControl({ value: '', disabled: false }, [
        Validators.required,
      ]),
      mapBusinessType: new FormControl(
        { value: '', disabled: false }, [Validators.required]
      ),
      displayName: new FormControl({ value: '', disabled: false }, [
        Validators.required,
      ]),


   expiryDateTogel: new FormControl({ value: '', disabled: false }),
    documentExpiryDate: new FormControl({ value: '', disabled: false }),
    selectReasonDropDown: new FormControl({ value: '', disabled: false }),
    statusId: new FormControl({ value: '', disabled: false }),

    docAcceptance: new FormControl({ value: '', disabled: false }),

      citySearch: new FormControl({ value: '', disabled: false }, []),
      stateSearch: new FormControl({ value: '', disabled: false }, []),
      businessDoc: new FormArray([]),
    });



  }
  statusWorkFlow: any[] = [];
  statusWorkFlowTmp: any[] = [];
  fetchAllBusinessWorkFlow() {
    this.validationService.fetchAllBusinessWorkFlow().then(res => {
      if (res.status == 'SUCCESS') {
        this.statusWorkFlow = res.data;
        this.businessWorkFlowTmp = this.statusWorkFlow;
      }
    })
  }

  initializeBusinessDocForm(businessDoc: any): void {


    // Populate form with data
    businessDoc.forEach((dataItem: any) => {
      this.date = '';
      if (this.isPriority && dataItem.documentExpiryDate != undefined) {
        if (dataItem?.documentExpiryDate.length > 0) {
          const convertDate = new Date(dataItem?.documentExpiryDate);
          this.date = this.datePipe.transform(convertDate, 'yyyy-MM-dd');
        }
      } else {
        this.date = dataItem.documentExpiryDate
      }

      this.docFormGroup = this.fb.group({
        id: [dataItem.id],
        value: [dataItem.value],
        issueDate: [dataItem.issueDate],
        legalDocumentId: [dataItem.legalDocumentId],
        legalDocumentName: [dataItem.legalDocumentName],
        documentNo: [dataItem.documentNo],

        expiryDateTogel: [
          { value: (dataItem.documentExpiryDate === '' || dataItem.documentExpiryDate === undefined) ? false : true, disabled: false }
        ],

        documentExpiryDate: [
          { value: (dataItem.documentExpiryDate === '' || dataItem.documentExpiryDate === undefined) ? '' : this.date, disabled: false }
        ],
        remarks: [dataItem.remarks],
        reasons: [dataItem.reasons, Validators.required],
        //docAcceptance: [dataItem.docAcceptance],
        docAcceptanceArray: new FormArray([]),
        //expiryDateTogel: [false],
        docAcceptance: [dataItem.docAcceptance || false],
        // selectReasonDropDown: this.docVarifyOnOffVal? this.getReason(dataItem.reasons) : ''
        selectReasonDropDown: this.getReason(dataItem.reasons),
        // statusId: [dataItem.docAcceptance ? 50 : null]
      });

      // if(dataItem.docAcceptance) {
      //   this.myForm.get('statusId').setValue(50);
      // }

      const docAcceptanceArray = this.docFormGroup.get(
        'docAcceptanceArray'
      ) as FormArray;

      dataItem.docAcceptanceArray.forEach((acceptanceItem: any) => {
        if (acceptanceItem != null) {
          let _date: any;
          if (acceptanceItem.type == 'DATE') {
            if (acceptanceItem?.value && acceptanceItem?.value.length > 0) {
              const convertDate = new Date(acceptanceItem?.value);
              _date = this.datePipe.transform(convertDate, 'yyyy-MM-dd');
            }
          }

          docAcceptanceArray.push(
            this.fb.group({
              // statusId: [{ value: acceptanceItem.statusId, disabled: false }],
              statusId: [{ value: dataItem.docAcceptance ? 50 : null, disabled: false }],
              name: [{ value: acceptanceItem.name, disabled: true }],
              label: [acceptanceItem.label],
              legDocId: [acceptanceItem.legDocId],
              type: [acceptanceItem.type],

              value: [{ value: acceptanceItem.type == 'DATE' ? _date : acceptanceItem.value, disabled: true }, [
                Validators.required,
              ]],
              fieldId: [acceptanceItem.fieldId],
            })
          );
        }
      });

      (this.myForm.get('businessDoc') as FormArray).push(this.docFormGroup);
    });
    if (this.persentMode === 0) {
      this.myForm.disable()
    }
    this.showAfterContent = true;
    setTimeout(() => {
      this.validDocumentAcceptance();
    }, 1000)

  }



  ngOnInit() {
    // this.init();
    this.route.params.subscribe((params) => {
      this.validationId = params['id'];
      this.persentMode = params['type'];
    });

    this.route.paramMap.subscribe(params => {
      this.currentStatus = this.validationService.getStatusId();
    });

    this.getState();
    this.getCity();
    this.getDocStatus();
    this.getValidationDetails();
    this.getUserInfo();
    this.getProdCategory();
    setTimeout(() => {
      // this.getValidationDetails();
      this.getQualification();
      this.ispageLoading = true;
      setTimeout(() => {
        this.magnify("myimage", 3);
        this.mouseOutIn();
      }, 1000)
    }, 500)
  }


  goBack() {
    this.location.back();
  }


  openDatePicker(datePicker: MatDatepicker<Date>) {
    datePicker.open();
  }


  getMinDate() {
    return new Date(
      this.today.getFullYear() - 18,
      this.today.getMonth(),
      this.today.getDate()
    );
  }

  getSelectedReason(i: number, controls: string) {
    return this.getDocuments.at(i).get(controls)?.value;
  }


  getReason(reason: string): number {
    let id: number = 0;
    if (reason && reason.length > 0) {
      id = this.reasonArray.filter(
        (value: any) => value.value === reason
      )[0];
      return id > 0 ? id : 5;
    }

    return id;
  }

  getSelectedReasons(selectReason: number | null): string {
    if (selectReason != null) {
      return this.reasonArray.filter(
        (value: any) => value.id == selectReason
      )[0].name;
    }
    else {
      return '';
    }
  }

  updateSelectReason(selectReason: number, index: number) {
    console.log(selectReason)
    if (selectReason == 5) {
      this.getDocuments.at(index).get("reasons")?.setValue(this.getSelectedReasons(null));
    } else {
      this.getDocuments.at(index).get("reasons")?.setValue(this.getSelectedReasons(selectReason));
    }
    this.validDocumentAcceptance();
    this.selectReason = selectReason;
    this.docVerifyVal = selectReason;
    if(this.docVerifyVal) {
      this.docVerifyError = false
    }

  }

  getQualification() {
    this.loadingCounter++
    this.register
      .fetchQualification()
      .then((res) => {
        this.hideLoader()
        if (res.status === ResponseStatus.SUCCESS) {
          this.qualificationList = res.data;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getValidationDetails() {
    this.loading = true;
    this.loadingCounter++;

    this.validationService.fetchValidationDetails(this.validationId).then(res => {
      this.hideLoader();
      if (res.status !== ResponseStatus.SUCCESS) return;

      this.validationDocuments = res.data;
      this.currentStatusName = res.data.business?.statusName;
      this.currentStatus = res.data.business?.statusId;
      this.selectedFile = this.getSelectedFile(res.data.businessDocs);
      this.documentAcceptanceData = this.getDocumentAcceptanceData(res.data.businessDocs);
      this.initializeBusinessDocForm(res.data.businessDocs);

      this.updateUserForm(res.data.user);
      this.updateBusinessForm(res.data.business);
      this.setPincodeInfo(res.data.address);
      this.disableLocationFields();

      this.getBusinessWorkFlow(res.data.business.statusId);

      if (this.isPriority) {
        this.setPriorityFields(res.data.business);
      }
    }).catch(error => {
      console.error(error);
    });
  }
  private getSelectedFile(businessDocs: any[]) {
    return businessDocs?.[0]
      ? { value: businessDocs[0].value, id: businessDocs[0].id }
      : '';
  }

  private getDocumentAcceptanceData(businessDocs: any[]) {
    return businessDocs?.[0]?.documentAcceptance || null;
  }

  private updateUserForm(user: any) {
    this.myForm.patchValue({
      salutationId: user.salutationId,
      firstName: user.firstName,
      lastName: user.lastName,
      dateOfBirth: user.dateOfBirth,
      emailId: user.emailId,
      contactNumber: user.contactNumber,
      registeredAddress: user.address,
      cityId: user.city
        ? this.cityList.find((c: any) => c.name === user.city)?.id
        : user.cityId,
      stateId: user.stateId
    });
  }

  private updateBusinessForm(business: any) {
    this.myForm.patchValue({
      businessEmailId: business.businessEmailId,
      custSupportEmailId: business.custSupportEmailId,
      businessNumber: business.businessNumber,
      custSupportNo: business.custSupportNo,
      whatsappNumber: business.whatsappNumber,
      websiteURL: business.websiteURL,
    });

    this.myForm.patchValue({ eduQualificationId: this.validationDocuments.eduQualificationId });
  }

  private disableLocationFields() {
    this.myForm.get('stateId').disable();
    this.myForm.get('cityId').disable();
  }

  private setPincodeInfo(address: any) {
    if (address) {
      this.myForm.patchValue({ pincode: address.pincode });
      this.pincodeInfo(address);
    }
  }

  private setPriorityFields(business: any) {
    this.myForm.get('proCategory').setValue(business.mappedCategory);
    this.setSubCategory(business.mappedCategory, business.mappedSubCategory);

    const mapBusinessType = this.mapBusinesstype.find(
      (item: any) => item.stringId === business.mappedBusinessType
    );
    this.myForm.get('mapBusinessType').setValue(mapBusinessType?.id || null);

    this.myForm.get('displayName').setValue(business.displayName);
  }



  changeDocument(document: any) {
    this.selectedFile = {
      id: document.id,
      value: document.value,
    };
    setTimeout(() => {
      const imageElement = document.getElementById('myimage') as HTMLImageElement;
      if (imageElement) {
        this.magnify('myimage', 3); // Adjust zoom level as needed
        this.mouseOutIn();
      }
    });
  }

  selectStatus: number = 0;
  selectStatusClick(event: any) {
    let status = event.target.value

    this.selectStatusTitle = status.toStatus;
    // this.selectStatus = status.toStatusId;
    this.selectStatus = status;
    const selectedItemIndex = this.businessWorkFlow.findIndex((item: any) => item.toStatusId === status);
    if (selectedItemIndex !== -1) {
      this.myForm.get('selectStatus').setValue(selectedItemIndex);
      this.myForm.get('selectStatus').updateValueAndValidity();
    }
  }

  openDocViewURl() {
    return `https://view.officeapps.live.com/op/embed.aspx?src=${this.selectedFile.value}`;
  }

  filterOptions(event: any): void {
    const value = event.target.value.toLowerCase();
    this.filteredState = this.stateList.filter((option: any) =>
      option?.name?.toLowerCase().includes(value)
    );
  }

  clearFilterOptions() {
    this.myForm.patchValue({ stateSearch: '' });
    this.filteredState = this.stateList;
  }

  filterCityOptions(event: any): void {
    const value = event.target.value.toLowerCase();
    this.filteredCity = this.cityList.filter((option: any) =>
      option?.name?.toLowerCase().includes(value)
    );
  }

  clearFilterCityOptions() {
    this.myForm.patchValue({ citySearch: '' });
    this.filteredCity = this.cityList;
  }
  numberOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  handlePasteNumber(event: any) {
    const value = event.clipboardData.getData('Text');
    const pattern = /[0-9]/g;
    if (value.match(pattern).length !== value.length) {
      event.preventDefault();
    }
  }

  stopSpaceSelect(event: any) {
    event.keyCode != 32 ? event : event.preventDefault();
  }

  pincodeInfoGet(pincode: any) {
    let value = pincode.value ? pincode.value : pincode;
    if (/^(^\d{6})$/.test(value)) {
      this.register
        .fetchStateByPincode(value)
        .then((res) => {
          if (res.status === ResponseStatus.SUCCESS) {
            if (res.data.cityName) {
              this.myForm.get('cityId').disable();
            } else {
              this.myForm.get('cityId').enable();
            }
            if (res.data.stateId) {
              this.myForm.get('stateId').disable();
            } else {
              this.myForm.get('stateId').enable();
            }

            this.myForm.patchValue({ cityId: res.data.cityId });
            this.myForm.patchValue({ stateId: res.data.stateId });
          } else {
            this.myForm.patchValue({ cityId: '' });
            this.myForm.patchValue({ stateId: '' });
            this.myForm.get('cityId').enable();
            this.myForm.get('stateId').enable();
          }
        })
        .catch((error) => {
          this.myForm.get('cityId').enable();
          this.myForm.get('stateId').enable();
        });
    } else {
      this.myForm.get('cityId').disable();
      this.myForm.get('stateId').disable();
    }
  }

  get getDocuments() {
    return (this.myForm.get('businessDoc').controls) as FormArray;
  }


  pincodeInfo(address: any) {

    this.register
      .fetchStateByPincode(address.pincode)
      .then((res) => {
        if (res.status === ResponseStatus.SUCCESS) {
          if (res.data.cityName) {
            this.myForm.get('cityId').disable();
          } else {
            this.myForm.get('cityId').enable();
          }
          if (res.data.stateId) {
            this.myForm.get('stateId').disable();
          } else {
            this.myForm.get('stateId').enable();
          }

          this.myForm.patchValue({ cityId: res.data.cityId });
          this.myForm.patchValue({ stateId: res.data.stateId });
        } else {
          let cityId = this.cityList.filter((c: any) => c.name == address.city)[0].id;
          this.myForm.patchValue({
            cityId: cityId,
            stateId: address.stateId
          })

          this.myForm.get('cityId').enable();
          this.myForm.get('stateId').enable();
        }
      })
      .catch((error) => {
        this.myForm.get('cityId').enable();
        this.myForm.get('stateId').enable();
      });

  }

  getCity() {
    this.register
      .fetchCity()
      .then((res) => {
        if (res.status === ResponseStatus.SUCCESS) {
          this.cityList = res.data;
          this.filteredCity = res.data;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getState() {
    this.register
      .fetchState()
      .then((res) => {
        if (res.status === ResponseStatus.SUCCESS) {
          this.stateList = res.data;
          this.filteredState = res.data;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getDocStatus() {
    this.loadingCounter++
    this.validationService
      .fetchDocStatus()
      .then((res) => {
        this.hideLoader()
        if (res.status === ResponseStatus.SUCCESS) {
          this.docStatusList = res.data;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getProdCategory() {
    this.loadingCounter++
    this.validationService
      .fetchProdCategory()
      .then((res: any) => {
        this.hideLoader()
        if (res.status == ResponseStatus.SUCCESS) {
          this.proCategoryList = res.data;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }


  selectMainCategory(event: any) {
    let id = event.value;
    this.getSubCategory(id);
  }
  getSubCategory(mainCat: number) {
    this.subCategoryList = null;
    this.loadingCounter++
    this.validationService
      .fetchSubCategory(mainCat)
      .then((res: any) => {
        this.hideLoader()
        if (res.status == ResponseStatus.SUCCESS) {
          this.subCategoryList = res.data;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  setSubCategory(mainCat: number, subCategory: string) {
    this.subCategoryList = null;
    this.loadingCounter++
    this.validationService
      .fetchSubCategory(mainCat)
      .then((res: any) => {
        this.hideLoader()
        if (res.status == ResponseStatus.SUCCESS) {
          this.subCategoryList = res.data;
          this.myForm.get('subCategory').setValue(subCategory);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getSellerProfileData() {
    this.loadingCounter++
    this.profileService
      .fetchSellerProfileDetails(this.businessParam)
      .then((res) => {
        this.hideLoader()
        if (res.status == ResponseStatus.SUCCESS) {
          this.sellerProfilePageData = res.data;
        }
      });
  }

  getUserInfo() {
    this.loadingCounter++
    this.register.fetchUserDetails().then((res) => {
        this.hideLoader()
        if (res.status === ResponseStatus.SUCCESS) {
          this.userInfo = res.data.user;

          this.validationService.fetchValidationDetails(this.validationId).then((res) => {
            if (res.status === ResponseStatus.SUCCESS) {
              this.validationDocuments = res.data;
              if (this.isPriority) {
                this.title = 'Approval';
                // this.myForm.get('remarks').setValidators(null);
                this.myForm.get('mapBusinessType').setValidators([Validators.required]);
                this.myForm.get('proCategory').setValidators([Validators.required]);
                this.myForm.get('subCategory').setValidators([Validators.required]);
                this.myForm.get('displayName').setValidators([Validators.required]);
              } else {
                // this.myForm.get('remarks').setValidators([Validators.required]);
                this.myForm.get('mapBusinessType').setValidators(null);
                this.myForm.get('proCategory').setValidators(null);
                this.myForm.get('subCategory').setValidators(null);
                this.myForm.get('displayName').setValidators(null);
              }
            }
          })

        }
      })
      .catch((error) => {
        console.log("Admin", error);
      });
  }

  getBusinessWorkFlow(statusId: any) {
    this.loadingCounter++
    this.validationService
      .fetchBusinessWorkFlow(statusId)
      .then((res) => {
        this.hideLoader();
        if (res.status === ResponseStatus.SUCCESS) {
          let businessWorkFlow = res.data;

          this.businessWorkFlowTmp = this.businessWorkFlow = businessWorkFlow.filter(
            (item: any) => item.groupBy != 'INLINE'
          );
          this.businessWorkFlowFOLLOW = this.businessWorkFlow.filter(
            (item: any) => item.groupBy == 'FOLLOW_UP'
          );

          this.businessWorkFlowApproved = this.businessWorkFlow.filter(
            (item: any) => item.groupBy == 'APPROVE'
          );
          console.log(this.businessWorkFlowApproved);

          this.businessWorkFlowReject = this.businessWorkFlow.filter(
            (item: any) => item.groupBy == 'REJECT'
          );
          console.log(this.businessWorkFlowReject);

        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  clickfollowUp() {
    this.togglefollowup();
  }

  clickEscalate() {
    this.toggleesclate();
  }

  get isPriority(): boolean {
    if(this.currentStatus?.fromStatusId !== 25 && this.currentStatus?.fromStatusId !== 26 && this.currentStatus?.fromStatusId !== 38 && this.currentStatus?.fromStatusId !== 33) {
      if(this.userInfo.roleName === 'ADMIN') {
        return true;
      }
      else if(this.userInfo.roleName === 'PROGRAM_MANAGER') {
        return true;
      }
      else {
        return false;
      }
    }
    else {
      return false;
    }
  }
  updateValidationDetail() {
    const businessDocs = this.myForm.get('businessDoc') as FormArray;
      this.isValid =  businessDocs.controls.some( doc =>{
      let docAcceptance = doc.get('docAcceptance')?.value;
      let reason = doc.get('selectReasonDropDown')?.value;
      let expiryDateTogel = doc.get('expiryDateTogel')?.value;
      let documentExpiryDate = doc.get('documentExpiryDate')?.value;
      return ((docAcceptance && !reason) || (expiryDateTogel && documentExpiryDate.length == 0));
    })
    this.validDocumentAcceptancePM();
      this.onSubmit();
    this.myForm.markAllAsTouched();
    if (this.isPriority) {
      console.log("User is an ADMIN");
      // this.myForm.get('remarks').setValidators(null);
      this.myForm.get('mapBusinessType').setValidators([Validators.required]);
      this.myForm.get('proCategory').setValidators([Validators.required]);
      this.myForm.get('subCategory').setValidators([Validators.required]);
      this.myForm.get('displayName').setValidators([Validators.required]);
    } else {
      console.log("User is not an ADMIN");
      // this.myForm.get('remarks').setValidators([Validators.required]);
      this.myForm.get('mapBusinessType').setValidators(null);
      this.myForm.get('proCategory').setValidators(null);
      this.myForm.get('subCategory').setValidators(null);
      this.myForm.get('displayName').setValidators(null);
    }
    if (this.businessWorkFlow.length == 0) {
      this.myForm.get('selectStatus').setValidators(null);
      this.myForm.controls['selectStatus'].setValue(this.validationDocuments.business.statusId);
      this.selectStatus = this.validationDocuments.business.statusId;
    }
    this.myForm.controls['cityId'].enable();
    this.myForm.controls['stateId'].enable();
    this.myForm.updateValueAndValidity();

    if (this.myForm.valid) {

      if (this.selectStatus == 0) {
        this.myForm.markAllAsTouched();
        return
      }

      this.myForm.controls['cityId'].disable();
      this.myForm.controls['stateId'].disable();
      const mapBusinesstypeId = this.mapBusinesstype.filter((item: any) => item.id == this.myForm.get('mapBusinessType').value)[0];
      const eduQualificationName = this.qualificationList.filter((item: any) => item.id == this.myForm.get('eduQualificationId').value)[0];
      const newBusinessDoc = this.myForm.get('businessDoc').value;
      // const newBusinessDoc = this.myForm.get('businessDoc').value.map((doc: any) => {
      //   debugger
      //   return {
      //       ...doc,
      //       // docAcceptance: this.docVarifyOnOffVal
      //       docAcceptance:  this.docFormGroup.value.docAcceptance
      //   };
      // });

      const finalSubmitDoc: any = [];
      for (let item of newBusinessDoc) {
        const newdocumentAcceptance = [];
        console.log("items => ", item)
        for (let subItem of item?.docAcceptanceArray) {
          console.log("subItem", subItem);
          if (subItem.docAcceptance) {
            if (subItem.statusId === undefined && subItem.statusId === "" && subItem.statusId === null) {
              newdocumentAcceptance.push(subItem);
            } else {
              const _submitDocSub: any = {};
              _submitDocSub.statusId = subItem?.statusId;
              _submitDocSub.fieldId = subItem?.fieldId;
              newdocumentAcceptance.push(_submitDocSub);
              // item.remarks = this.myForm.get('remarks').value
              if (this.selectReason == 5) {
                // item.reasons = this.myForm.get('otherReson').value
              } else {
                // item.reasons = this.myForm.get('selectReasonDropDown').value
              }
            }
          }
        }
        item.documentAcceptance = newdocumentAcceptance
        if (this.isPriority) {
          let _updateDateFormat: any;
          if (item.documentExpiryDate != undefined) {
            if (!item.expiryDateTogel) item.documentExpiryDate = '';
            if (item.documentExpiryDate && item.documentExpiryDate.length > 0) {
              const _convertDate = new Date(item?.documentExpiryDate);
              _updateDateFormat = this.datePipe.transform(_convertDate, 'yyyy-MM-dd');
              item.documentExpiryDate = _updateDateFormat
            }
          }
        }
        finalSubmitDoc.push(item)
      }
      console.log("finalSubmitDoc", finalSubmitDoc);
      let dateOfBirth: any = "";
      if (this.myForm.get('dateOfBirth').value) {
        const convertDate = new Date(this.myForm.get('dateOfBirth').value);
        dateOfBirth = this.datePipe.transform(convertDate, 'dd/MM/yyyy');
      }
      let payload = {
        "user": {
          "id": this.validationDocuments.user.id,
          "name": this.myForm.get('firstName').value,
          "firstName": this.myForm.get('firstName').value,
          "lastName": this.myForm.get('lastName').value,
          "contactNumber": this.myForm.get('contactNumber').value,
          "emailId": this.myForm.get('emailId').value,
          "address": this.myForm.get('registeredAddress').value,
          "cityId": this.myForm.get('cityId').value,
          "stateId": this.myForm.get('stateId').value,
          "pincode": this.myForm.get('pincode').value,
          "salutationId": this.myForm.get('salutationId').value,
          "dateOfBirth": dateOfBirth

        },
        "business": {
          "id": this.validationDocuments.business.id,
          "legalBusinessName": this.validationDocuments.business.legalBusinessName,
          "businessEmailId": this.myForm.get('businessEmailId').value,
          "websiteURL": this.myForm.get('websiteURL').value,
          "businessNumber": this.myForm.get('businessNumber').value,
          "whatsappNumber": this.myForm.get('whatsappNumber').value,
          "mappedCategory": this.myForm.get('proCategory').value,
          "registeredAddress": this.validationDocuments.business.registeredAddress,
          "custSupportNo": this.myForm.get('custSupportNo').value,
          "statusId": this.selectStatus,
          "businessIncorporationDate": this.validationDocuments.business.businessIncorporationDate,
          "custSupportEmailId": this.myForm.get('custSupportEmailId').value,
          "mappedSubCategory": this.myForm.get('subCategory').value,
          "userId": this.validationDocuments.business.userId,
          "entityTypeID": this.validationDocuments.business.entityTypeID,
          "mappedBusinessType": mapBusinesstypeId?.stringId,
          "displayName": this.myForm.get('displayName').value
        },
        "eduQualificationId": this.myForm.get('eduQualificationId').value,
        "eduQualification": eduQualificationName?.name,
        "businessDocs": finalSubmitDoc,
        "address": this.validationDocuments.address
      }
      if (payload.address) {
        payload.address["address"] = this.myForm.get('registeredAddress').value;
        payload.address["cityId"] = this.myForm.get('cityId').value;
        payload.address["city"] = this.cityList.filter((c: any) => c.id == this.myForm.get('cityId').value)[0].name;
        payload.address["stateId"] = this.myForm.get('stateId').value;
        payload.address["state"] = this.stateList.filter((c: any) => c.id == this.myForm.get('stateId').value)[0].name;
        payload.address["pincode"] = this.myForm.get('pincode').value;
        payload.address["pincodeId"] = null;
      }
      if (!this.isPriority) {
        delete payload.business.mappedCategory;
        delete payload.business.mappedSubCategory;
        delete payload.business.mappedBusinessType;
      } else {
        if (this.myForm.get('subCategory').value == 0 || this.myForm.get('proCategory').value == 0) {
          if (this.myForm.get('subCategory').value == 0) this.myForm.get('subCategory').setValue("");
          if (this.myForm.get('proCategory').value == 0) this.myForm.get('proCategory').setValue("");
          this.myForm.updateValueAndValidity();
          this.myForm.markAllAsTouched();
          return;
        }
      }
      console.log("payload", payload)
      this.loading = true;
      this.validationService
        .validationDetailSave(payload)
        .then((res) => {
          this.loading = false;
          if (res.status == ResponseStatus.SUCCESS) {
            this.customSnackbarService.openCustomSnackbar("Validation Details updated successfully.", 2000);
            this.router.navigate(["/validation-listing"])
          }
        });
    } else {
      console.log(this.myForm);
      this.myForm.markAllAsTouched();
    }
    if (this.isPriority) {
      console.log("User is an ADMIN");
      // this.myForm.get('remarks').setValidators(null);
      this.myForm.get('mapBusinessType').setValidators([Validators.required]);
      this.myForm.get('proCategory').setValidators([Validators.required]);
      this.myForm.get('subCategory').setValidators([Validators.required]);
      this.myForm.get('displayName').setValidators([Validators.required]);
    } else {
      console.log("User is not an ADMIN");
      // this.myForm.get('remarks').setValidators([Validators.required]);
      this.myForm.get('mapBusinessType').setValidators(null);
      this.myForm.get('proCategory').setValidators(null);
      this.myForm.get('subCategory').setValidators(null);
      this.myForm.get('displayName').setValidators(null);
    }
    if (this.businessWorkFlow.length == 0) {
      this.myForm.get('selectStatus').setValidators(null);
      this.myForm.controls['selectStatus'].setValue(this.validationDocuments.business.statusId);
      this.selectStatus = this.validationDocuments.business.statusId;
    }
    this.myForm.controls['cityId'].enable();
    this.myForm.controls['stateId'].enable();
    this.myForm.updateValueAndValidity();
    if (this.myForm.valid) {
      if (this.selectStatus == 0) {
        this.myForm.markAllAsTouched();
        return
      }
      this.myForm.controls['cityId'].disable();
      this.myForm.controls['stateId'].disable();
      const mapBusinesstypeId = this.mapBusinesstype.filter((item: any) => item.id == this.myForm.get('mapBusinessType').value)[0];
      const eduQualificationName = this.qualificationList.filter((item: any) => item.id == this.myForm.get('eduQualificationId').value)[0];
      const newBusinessDoc = this.myForm.get('businessDoc').value;
      const finalSubmitDoc: any = [];
      for (let item of newBusinessDoc) {
        const newdocumentAcceptance = [];
        for (let subItem of item?.docAcceptanceArray) {
          if (subItem.docAcceptance) {
            if (subItem.statusId === undefined && subItem.statusId === "" && subItem.statusId === null) {
              newdocumentAcceptance.push(subItem);
            } else {
              const _submitDocSub: any = {};
              _submitDocSub.statusId = subItem?.statusId;
              _submitDocSub.fieldId = subItem?.fieldId;
              newdocumentAcceptance.push(_submitDocSub);
              // item.remarks = this.myForm.get('remarks').value
              if (this.selectReason == 5) {
                // item.reasons = this.myForm.get('otherReson').value
              } else {
                // item.reasons = this.myForm.get('selectReasonDropDown').value
              }
            }
          }
        }
        item.documentAcceptance = newdocumentAcceptance

        if (this.isPriority) {
          let _updateDateFormat: any;
          if (item.documentExpiryDate != undefined) {
            if (!item.expiryDateTogel) item.documentExpiryDate = '';
            if (item.documentExpiryDate && item.documentExpiryDate.length > 0) {
              const _convertDate = new Date(item?.documentExpiryDate);
              _updateDateFormat = this.datePipe.transform(_convertDate, 'yyyy-MM-dd');
              item.documentExpiryDate = _updateDateFormat
            }
          }
        }
        finalSubmitDoc.push(item)
      }
      let dateOfBirth: any = "";
      if (this.myForm.get('dateOfBirth').value) {
        const convertDate = new Date(this.myForm.get('dateOfBirth').value);
        dateOfBirth = this.datePipe.transform(convertDate, 'dd/MM/yyyy');
      }

      let payload = {
        "user": {
          "id": this.validationDocuments.user.id,
          "name": this.myForm.get('firstName').value,
          "firstName": this.myForm.get('firstName').value,
          "lastName": this.myForm.get('lastName').value,
          "contactNumber": this.myForm.get('contactNumber').value,
          "emailId": this.myForm.get('emailId').value,
          "address": this.myForm.get('registeredAddress').value,
          "cityId": this.myForm.get('cityId').value,
          "stateId": this.myForm.get('stateId').value,
          "pincode": this.myForm.get('pincode').value,
          "salutationId": this.myForm.get('salutationId').value,
          "dateOfBirth": dateOfBirth

        },
        "business": {
          "id": this.validationDocuments.business.id,
          "legalBusinessName": this.validationDocuments.business.legalBusinessName,
          "businessEmailId": this.myForm.get('businessEmailId').value,
          "websiteURL": this.myForm.get('websiteURL').value,
          "businessNumber": this.myForm.get('businessNumber').value,
          "whatsappNumber": this.myForm.get('whatsappNumber').value,
          "mappedCategory": this.myForm.get('proCategory').value,
          "registeredAddress": this.validationDocuments.business.registeredAddress,
          "custSupportNo": this.myForm.get('custSupportNo').value,
          "statusId": this.selectStatus,
          "businessIncorporationDate": this.validationDocuments.business.businessIncorporationDate,
          "custSupportEmailId": this.myForm.get('custSupportEmailId').value,
          "mappedSubCategory": this.myForm.get('subCategory').value,
          "userId": this.validationDocuments.business.userId,
          "entityTypeID": this.validationDocuments.business.entityTypeID,
          "mappedBusinessType": mapBusinesstypeId?.stringId,
          "displayName": this.myForm.get('displayName').value
        },
        "eduQualificationId": this.myForm.get('eduQualificationId').value,
        "eduQualification": eduQualificationName?.name,
        "businessDocs": finalSubmitDoc,
        "address": this.validationDocuments.address
      }
      if (payload.address) {
        payload.address["address"] = this.myForm.get('registeredAddress').value;
        payload.address["cityId"] = this.myForm.get('cityId').value;
        payload.address["city"] = this.cityList.filter((c: any) => c.id == this.myForm.get('cityId').value)[0].name;
        payload.address["stateId"] = this.myForm.get('stateId').value;
        payload.address["state"] = this.stateList.filter((c: any) => c.id == this.myForm.get('stateId').value)[0].name;
        payload.address["pincode"] = this.myForm.get('pincode').value;
        payload.address["pincodeId"] = null;
      }
      if (!this.isPriority) {
        delete payload.business.mappedCategory;
        delete payload.business.mappedSubCategory;
        delete payload.business.mappedBusinessType;
      } else {
        if (this.myForm.get('subCategory').value == 0 || this.myForm.get('proCategory').value == 0) {
          if (this.myForm.get('subCategory').value == 0) this.myForm.get('subCategory').setValue("");
          if (this.myForm.get('proCategory').value == 0) this.myForm.get('proCategory').setValue("");
          this.myForm.updateValueAndValidity();
          this.myForm.markAllAsTouched();
          return;
        }
      }
      this.loading = true;
    } else {
      this.myForm.markAllAsTouched();
    }
  }
  expireDateOnChange(event: any, index: number) {
    const formArray = this.myForm.get('businessDoc') as FormArray;
    const formGroup = formArray.at(index) as FormGroup;
    const expiryDateTogelControl = formGroup.get('expiryDateTogel');
    const documentExpiryDateControl = formGroup.get('documentExpiryDate');
      this.expireDateError = false;

    this.expireDateOnOffVal = event.target.checked;
    if (!this.expireDateOnOffVal) {
      documentExpiryDateControl?.setValidators(null)
      documentExpiryDateControl?.setValue('');
    }
    else {
      documentExpiryDateControl?.setValidators(Validators.required)
    }
  }
  expireDateChange(event: MatDatepickerInputEvent<Date>, index: number) {
    const formArray = this.myForm.get('businessDoc') as FormArray;
    const formGroup = formArray.at(index) as FormGroup;
    const documentExpiryDateControl = formGroup.get('documentExpiryDate');
      this.expireDateError = false;
    this.expireDateVal = event.value;
    console.log(this.expireDateVal)
    if (this.expireDateVal || this.expireDateVal !== null) {
      documentExpiryDateControl?.setValue(this.expireDateVal);
    } else {
      documentExpiryDateControl?.setValue('');
    }
  }
  hideLoader() {
    this.loadingCounter--
    if (this.loadingCounter === 0) {
      this.loading = false
    }
    if (this.persentMode == 0) {
      this.myForm.disable()
    }
  }
  getValid(formControl: string) {
    return (this.myForm.get(formControl).invalid || this.myForm.get(formControl).value == '')
  }
  isChecked(value: string): boolean {
    return value === '' ? false : true;
  }
  showSubmit() {
    let statusList: any[] = [
      "PM Rejected",
      "Agreement Signed",
      "Agreement Disagreed"
    ]
    return (statusList.findIndex(c => c === this.currentStatus) > 0)
  }
  getMatchingId() {
    return (this.docStatusList.find(status => status.name === "Matching")?.id)
  }
  validDocumentAcceptance1(event: any, index: number) {
    const formArray = this.myForm.get('businessDoc') as FormArray;
    const formGroup = formArray.at(index) as FormGroup;
    const docAcceptanceControl = formGroup.get('docAcceptance');
    const selectReasonControl = formGroup.get('selectReasonDropDown');
    const expiryDateTogelControl = formGroup.get('expiryDateTogel');
    const reasonsControl = formGroup.get('reasons');
    const docAcceptanceArray = formGroup.get('docAcceptanceArray') as FormArray;
    this.docVarifyOnOffVal = event.target.checked;
    if (this.docVarifyOnOffVal) {
        this.getDocuments.at(index).get("reasons")?.clearValidators();
        this.getDocuments.at(index).get("reasons")?.updateValueAndValidity();
        selectReasonControl?.setValue('');
        reasonsControl?.setValue('');
        expiryDateTogelControl?.setValue(false);
        docAcceptanceArray.controls.forEach(control => {
            const acceptanceItem = control as FormGroup;
            acceptanceItem.get('statusId')?.setValue('');
        });
    } else {
        this.getDocuments.at(index).get("reasons")?.setValidators(Validators.required);
        this.getDocuments.at(index).get("reasons")?.updateValueAndValidity();
        selectReasonControl?.setValue('');
    }
    this.getDocuments.at(index).get("reasons")?.updateValueAndValidity()
    this.validDocumentAcceptance(); // Assuming this function does additional validation
}
validDocumentAcceptance() {
  let isApproved = this.businessWorkFlowTmp.find((status: any) => (status.toStatus == 'V Approved' && status.groupBy !== "INLINE"));
  if (isApproved) {
      const formArray = this.myForm.get('businessDoc') as FormArray;
      let allDocsMatching = true;
      formArray.controls.forEach((control, index) => {
          const formGroup = control as FormGroup;
          const selectReasonControl = formGroup.get('reasons');
          const item = formGroup.value;
          if (item?.docAcceptance && item?.docAcceptanceArray?.length) {
              let allDocAcceptance = Array.from(item?.docAcceptanceArray).filter((doc: any) => (doc.statusId != this.getMatchingId()));
              if (allDocAcceptance.length > 0) {
                  allDocsMatching = false;
              } else {
                selectReasonControl?.clearValidators();
              }
          } else {
              allDocsMatching = false;
              selectReasonControl?.setValidators(Validators.required);
          }
          selectReasonControl?.updateValueAndValidity();
      });
      if (allDocsMatching) {
          let filtered = this.businessWorkFlow.filter((d: any) => d.toStatus == isApproved.toStatus);
          if (filtered.length == 0) {
              this.businessWorkFlow.push(isApproved);
          }
      } else {
          this.businessWorkFlow = this.businessWorkFlow.filter(d => d.toStatus !== isApproved.toStatus);
      }
  }
}
validDocumentAcceptancePM() {
      const formArray = this.myForm.get('businessDoc') as FormArray;
      let allDocsMatching = true;
      formArray.controls.forEach((control, index) => {
          const formGroup = control as FormGroup;
          const selectReasonControl = formGroup.get('reasons');
          const item = formGroup.value;
          if (item?.docAcceptance && item?.docAcceptanceArray?.length) {
              let allDocAcceptance = Array.from(item?.docAcceptanceArray).filter((doc: any) => (doc.statusId != this.getMatchingId()));
              if (allDocAcceptance.length > 0) {
                  allDocsMatching = false;
              } else {
                selectReasonControl?.clearValidators();
              }
          } else {
              allDocsMatching = false;
              selectReasonControl?.setValidators(Validators.required);
          }
          selectReasonControl?.updateValueAndValidity();
      });
}
  magnify(imgID: any, zoom: any) {
    let img: any = document.getElementById(imgID);
    if (!img) return;
    let existingGlass = document.querySelector('.img-magnifier-glass');
    if (existingGlass) existingGlass.remove();
    const glass = document.createElement("DIV");
    glass.setAttribute("class", "img-magnifier-glass");
    img.parentElement?.insertBefore(glass, img);
    glass.style.backgroundImage = `url('${img.src}')`;
    glass.style.backgroundRepeat = "no-repeat";
    glass.style.backgroundSize = `${img.width * zoom}px ${img.height * zoom}px`;
    const bw = 3;
    const w = glass.offsetWidth / 2;
    const h = glass.offsetHeight / 2;
    glass.addEventListener("mousemove", moveMagnifier);
    img.addEventListener("mousemove", moveMagnifier);
    glass.addEventListener("touchmove", moveMagnifier);
    img.addEventListener("touchmove", moveMagnifier);
    function moveMagnifier(e: any) {
      const pos = getCursorPos(e);
      let x = pos.x;
      let y = pos.y;
      if (x > img.width - w / zoom) x = img.width - w / zoom;
      if (x < w / zoom) x = w / zoom;
      if (y > img.height - h / zoom) y = img.height - h / zoom;
      if (y < h / zoom) y = h / zoom;
      glass.style.left = `${x - w}px`;
      glass.style.top = `${y - h}px`;
      glass.style.backgroundPosition = `-${x * zoom - w + bw}px -${y * zoom - h + bw}px`;
    }
    function getCursorPos(e: any) {
      const a = img.getBoundingClientRect();
      const x = e.pageX - a.left - window.pageXOffset;
      const y = e.pageY - a.top - window.pageYOffset;
      return { x, y };
    }
    glass.style.display = 'none';
  }
  mouseOutIn() {
    const trigger: any = document.querySelector('.img-magnifier-container') as any;
    const popup: any = document.querySelector('.img-magnifier-glass');
    if (trigger) {
      trigger.addEventListener('mouseenter', function () {
        if (popup) {
          // Get the image element and cast it as HTMLImageElement
          const img = document.getElementById('myimage') as HTMLImageElement;
          if (img) {
            popup.style.backgroundImage = `url('${img.src}')`;
            popup.style.backgroundSize = `${img.width * 2}px ${img.height * 2}px`;
          }
          popup.style.display = 'block';
        }
      });
      trigger.addEventListener('mouseleave', function () {
        if (popup) popup.style.display = 'none';
      });
    }
  }
  isValid = true;
  onSubmit() {
    const businessDocs = this.myForm.get('businessDoc') as FormArray;
    let isValid = true;
    for (let index = 0; index < businessDocs.controls.length; index++) {
      const doc = businessDocs.controls[index];
      const docAcceptance = doc.get('docAcceptance')?.value;
      const reason = doc.get('selectReasonDropDown')?.value;
      const expiryDateTogel = doc.get('expiryDateTogel')?.value;
      const documentExpiryDate = doc.get('documentExpiryDate')?.value;
      if (docAcceptance && reason === "") {
        isValid = false;
        if (expiryDateTogel && documentExpiryDate === "") {
          isValid = false;
        } else {
          if (documentExpiryDate !== "" && documentExpiryDate !== 0) {
            isValid = true;
          } else {
            isValid = false;
          }
        }
      } else {
        if (reason !== "" && reason !== 0) {
          isValid = true;
        } else {
          isValid = false;
        }
      }
      if (!isValid) {
        break;
      }
    }
    this.isValid = isValid;
    return this.isValid;
  }

}

